import { createSlice } from '@reduxjs/toolkit';
import { PAYOUT_DEFAULT_STATE } from '../types/payout.types';
import { updatePayout, fetchPayout } from '../actions/payout.actions';

const payoutSlice = createSlice({
    name: 'payout.info',
    initialState: PAYOUT_DEFAULT_STATE,
    reducers: {
        resetPayoutError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPayout.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPayout.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.form = action.payload;
            })
            .addCase(fetchPayout.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(updatePayout.pending, (state) => {
                state.updating = true;
                state.error = null;
            })
            .addCase(updatePayout.fulfilled, (state, action) => {
                state.updating = false;
                state.error = null;
                state.form = action.payload;
            })
            .addCase(updatePayout.rejected, (state, action) => {
                state.updating = false;
                state.error = action.payload as string;
            });
    }
});

export const { resetPayoutError } = payoutSlice.actions;
export const payoutReducer = payoutSlice.reducer;
